<div [innerText]="html | safe: 'html'"></div>